import * as classNames from 'classnames';
import * as React from 'react';
import { VideoInfo } from '../../VideoInfo';
import { LinkTile } from '../../../Common/LinkTile';
import { SVG } from '../../../Utils/SVG';
import { Video } from '../../../../models';
const playIconURL = require('../../../../icons/play.svg');
import './style.css';

export interface VideoTileProps {
  getVideoUrl: (video: Video) => string;
  video: Video;
}

export interface VideoTileState {
  /* empty*/
}

export class VideoTile extends React.Component<VideoTileProps, VideoTileState> {
  render() {
    const { getVideoUrl, video } = this.props;

    return (
      <LinkTile
        className={classNames({
          'index-tile video-mini-list-tile': true,
          'video-tile--premium': video.isPremium
        })}
        image={video.poster}
        url={getVideoUrl(video)}
      >
        <div className="video-mini-list-tile-content">
          <SVG className="video-mini-list-tile-play-icon" src={playIconURL} />
        </div>
        <VideoInfo
          data-slot="outside"
          className="video-mini-list-tile-details"
          video={video}
        />
      </LinkTile>
    );
  }
}

export default VideoTile;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoMiniList/VideoTile/index.tsx